// removed by extract-text-webpack-plugin
module.exports = {"fixedNavBar":"style__fixedNavBar___3TD7d","button":"style__button___2SUAU","logo":"style__logo___2nbBS"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/FixedNavBar/style.scss
 ** module id = 356
 ** module chunks = 0
 **/